module.exports = __webpack_public_path__ + "static/media/woman_showcase_item.56e65371.png";